import styled from 'styled-components'

export const ChatsPane = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  min-height: 0;
  --edge-fade-from: var(--sidebar);

  [data-collapsible='icon'] & {
    flex: 1 1 0;
    overflow: hidden;
  }
`

export const StickyChatChrome = styled.div`
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  background-color: var(--sidebar);
`

export const HistoryState = styled.div`
  display: flex;
  min-height: 5rem;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  text-align: center;

  [data-collapsible='icon'] & {
    display: none;
  }
`

export const HistoryLabelGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0.5rem 0;

  [data-collapsible='icon'] & {
    padding-top: 0.25rem;
  }
`

export const HistoryHeaderAction = styled.div`
  display: inline-flex;
  flex-shrink: 0;
  cursor: pointer;

  @media (hover: hover) and (pointer: fine) {
    opacity: 0;

    ${HistoryLabelGroup}:hover &,
    ${HistoryLabelGroup}:focus-within &,
    &[data-open] {
      opacity: 1;
    }
  }
`

export const HistoryToggleButton = styled.button`
  gap: 0.25rem;
  width: fit-content;
  height: 1.5rem;
  cursor: pointer;

  [data-collapsible='icon'] & {
    margin-top: -1.5rem;
    visibility: hidden;
  }

  &:hover {
    color: var(--sidebar-foreground);
  }
`

export const HistoryToggleChevron = styled.span`
  display: inline-flex;
  opacity: 0;
  transition: opacity 150ms var(--ease-out-strong);

  ${HistoryToggleButton}:hover &,
  ${HistoryToggleButton}:focus-visible & {
    opacity: 1;
  }
`

export const ArchivedSection = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 0 1 auto;

  [data-collapsible='icon'] & {
    display: none;
  }
`
